"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vernasca": {
    "0175e971": [{
      "hkey": "57484d6a",
      "slug": "bacedasco-basso",
      "name": "Bacedasco Basso",
      "primary": true,
      "skipSearch": false
    }],
    "bacedasco": [{
      "hkey": "57484d6a",
      "slug": "bacedasco-basso",
      "name": "Bacedasco Basso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4cf7fcd9": [{
      "hkey": "4ed2e413",
      "slug": "vernasca",
      "name": "Vernasca",
      "primary": true,
      "skipSearch": false
    }],
    "mignano": [{
      "hkey": "4ed2e413",
      "slug": "vernasca",
      "name": "Vernasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;